import { ReactNode } from "react";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faCheck, faCircleNotch, faHourglass, faQuestion, faTimes } from "@fortawesome/free-solid-svg-icons";

export function getStatusStyle(status: string): { bg: string, border: string, icon: IconDefinition, spin?: boolean, text: ReactNode } {
  switch (status) {
    case "pending":
      return { bg: "bg-amber-600", border: "border-amber-600", icon: faHourglass, text: <>Pending</> }
    case "running":
    case "in_progress":
      return { bg: "bg-blue-600", border: "border-blue-600", icon: faCircleNotch, spin: true, text: <>In&nbsp;progress</> }
    case "success":
    case "completed":
      return { bg: "bg-green-600", border: "border-green-600", icon: faCheck, text: <>Success</> }
    case "failed":
    case "error":
      return { bg: "bg-red-600", border: "border-red-600", icon: faTimes, text: <>Failed</> }
    default:
      return { bg: "bg-slate-600", border: "border-slate-600", icon: faQuestion, text: <>Unknown</> }
  }
}
